import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import CaregiverContactInfoDescription from '../../../components/FormDescriptions/CaregiverContactInfoDescription';
import { emailUI, phoneUI } from '../../../definitions/sharedUI';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['secondary-one-info-title--contact'];
const INPUT_LABEL = content['secondary-one-input-label'];

const { email, phone } = FULL_SCHEMA.definitions;

export default {
  uiSchema: {
    ...titleUI(
      TITLE_TEXT,
      CaregiverContactInfoDescription({ label: INPUT_LABEL }),
    ),
    secondaryOnePrimaryPhoneNumber: phoneUI(`${INPUT_LABEL} primary`),
    secondaryOneAlternativePhoneNumber: phoneUI(`${INPUT_LABEL} alternative`),
    secondaryOneEmail: emailUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: ['secondaryOnePrimaryPhoneNumber'],
    properties: {
      secondaryOnePrimaryPhoneNumber: phone,
      secondaryOneAlternativePhoneNumber: phone,
      secondaryOneEmail: email,
    },
  },
};
